var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSberbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sber"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 444700"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6762 3.88525C18.1449 4.49944 18.5417 5.1667 18.8586 5.87363L9.87007 12.5887L6.11353 10.2022V7.33114L9.87007 9.71765L17.6762 3.88525Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.27967 9.9998C2.27967 9.87097 2.28277 9.74299 2.28897 9.61574L0.0123986 9.50269C0.0046499 9.6676 2.75113e-06 9.83409 2.75113e-06 10.0021C-0.000965868 11.315 0.253848 12.6152 0.749835 13.828C1.24582 15.0409 1.97321 16.1425 2.89027 17.0698L4.5051 15.4341C3.79918 14.7215 3.23916 13.8746 2.85725 12.942C2.47533 12.0094 2.27905 11.0095 2.27967 9.9998Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.86801 2.31025C9.99507 2.31025 10.1213 2.31497 10.2469 2.32125L10.3608 0.0132513C10.1976 0.00539828 10.0333 0.00147226 9.86801 0.00147226C8.5719 -0.000129559 7.28833 0.257741 6.0909 0.760278C4.89345 1.26282 3.80576 2.00012 2.89026 2.92986L4.50509 4.56642C5.2082 3.85076 6.04396 3.283 6.96432 2.89581C7.88469 2.50862 8.87146 2.30962 9.86801 2.31025Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.86796 17.6902C9.7409 17.6902 9.61457 17.6902 9.4883 17.68L9.37439 19.9872C9.53814 19.9955 9.70268 19.9998 9.86796 19.9998C11.1635 20.0011 12.4465 19.7431 13.6433 19.2404C14.8401 18.7377 15.9271 18.0003 16.8419 17.0706L15.2301 15.4348C14.5269 16.1501 13.6912 16.7175 12.771 17.1046C11.8508 17.4916 10.8643 17.6907 9.86796 17.6902Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.1454 3.65166L16.064 2.21849C14.3104 0.779393 12.1214 -0.00399477 9.86499 1.53192e-05V2.30958C11.393 2.30766 12.8855 2.77563 14.1454 3.65166Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.7353 10.0003C19.7365 9.39949 19.6847 8.79971 19.5803 8.20825L17.4564 9.79455C17.4564 9.86291 17.4564 9.93121 17.4564 10.0003C17.457 11.0748 17.2347 12.1375 16.8041 13.1193C16.3735 14.1012 15.744 14.9804 14.9567 15.7L16.4886 17.4159C17.5122 16.4794 18.3303 15.3353 18.8896 14.0578C19.4489 12.7803 19.737 11.3979 19.7353 10.0003Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9.86803 17.6904C8.8077 17.6907 7.75912 17.4654 6.79014 17.029C5.82122 16.5926 4.9535 15.9548 4.24322 15.157L2.5509 16.7087C3.47491 17.7463 4.60378 18.5755 5.86432 19.1425C7.12485 19.7094 8.48889 20.0015 9.86803 19.9999V17.6904Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M4.77942 4.30011L3.24827 2.58423C2.22433 3.5206 1.40603 4.66463 0.846439 5.94214C0.286854 7.21963 -0.00152563 8.60207 6.06969e-06 9.9998H2.27968C2.27921 8.92535 2.50149 7.8627 2.93211 6.88082C3.36273 5.89897 3.99209 5.01974 4.77942 4.30011Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSberbank);
export default __webpack_public_path__ + "static/media/sberbank.7c0c379fdc6904eca80da6aea8a3e512.svg";
export { ForwardRef as ReactComponent };